import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Sanitize a free-text decimal input so the user can type either "3.2" or "3,2".
// Keeps digits and the first decimal separator the user typed; strips anything else.
export function sanitizeDecimalInput(raw: string): string {
  const cleaned = raw.replace(/[^\d.,]/g, '');
  const firstSepIdx = cleaned.search(/[.,]/);
  if (firstSepIdx < 0) return cleaned;
  const sep = cleaned[firstSepIdx];
  const before = cleaned.slice(0, firstSepIdx);
  const after = cleaned.slice(firstSepIdx + 1).replace(/[.,]/g, '');
  return before + sep + after;
}

// Parse a sanitized buffer to a number. Returns null while the input is still
// in-flight (empty, just a separator, or trailing separator like "3." / "3,").
export function parseDecimalInput(buffer: string): number | null {
  const trimmed = buffer.trim();
  if (trimmed === '' || trimmed === '.' || trimmed === ',') return null;
  const normalized = trimmed.replace(',', '.');
  if (normalized.endsWith('.')) return null;
  const n = parseFloat(normalized);
  return isNaN(n) ? null : n;
}
